export default "__VITE_ASSET__lZUK1Wzj__"